/**
 * @readonly
 * @enum {string}
 */
export const ItemState = {
    Unchecked: 'unchecked',
    Checked: 'checked',
    Indeterminate: 'indeterminate',
};
